import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Prev", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Next", -1)

import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    page: null,
    perPage: null,
    total: null
  },
  emits: ['update:page'],
  setup(__props: any, { emit }) {

const props = __props as {
  page: number,
  perPage: number,
  total: number,
}




const { page, perPage, total } = toRefs(props);
const lastPage = computed(() => Math.ceil(total.value / perPage.value));
const hasPrev = computed(() => page.value > 1);
const hasNext = computed(() => page.value < lastPage.value);

return (_ctx: any,_cache: any) => {
  const _component_icon_arrow_left = _resolveComponent("icon-arrow-left")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasPrev))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:page', _unref(page) - 1))),
          class: "group flex items-center space-x-2 hover:text-gray-900 mr-4"
        }, [
          _createVNode(_component_icon_arrow_left, { class: "w-5 h-5 text-gray-500 group-hover:text-gray-700" }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (_unref(hasNext))
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:page', _unref(page) + 1))),
          class: "group flex items-center space-x-2 hover:text-gray-900 ml-auto"
        }, [
          _hoisted_3,
          _createVNode(_component_icon_arrow_right, { class: "w-5 h-5 text-gray-500 group-hover:text-gray-700" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})